import { SHA256 } from 'crypto-js';

declare global {
  interface Window {
    FB: any;
    fbAsyncInit: () => void;
  }
}

export async function initFacebookSDK() {
  return new Promise<void>((resolve, reject) => {
    // Remove any existing FB SDK
    const existingScript = document.getElementById('facebook-jssdk');
    if (existingScript) {
      existingScript.remove();
    }

    // Add FB root div if it doesn't exist
    if (!document.getElementById('fb-root')) {
      const fbRoot = document.createElement('div');
      fbRoot.id = 'fb-root';
      document.body.appendChild(fbRoot);
    }

    // Initialize Facebook SDK
    window.fbAsyncInit = function() {
      const appId = import.meta.env.VITE_FB_APP_ID;
      if (!appId) {
        reject(new Error('Facebook App ID no configurado'));
        return;
      }

      window.FB.init({
        appId,
        cookie: true,
        xfbml: true,
        version: 'v19.0'
      });

      resolve();
    };

    // Load the SDK asynchronously
    (function(d, s, id) {
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      js = d.createElement(s) as HTMLScriptElement;
      js.id = id;
      js.src = "https://connect.facebook.net/es_LA/sdk.js";
      js.async = true;
      js.defer = true;
      js.crossOrigin = "anonymous";
      fjs.parentNode?.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));
  });
}

export async function loginWithFacebook(): Promise<{
  accessToken: string;
  phoneNumberId: string;
}> {
  return new Promise((resolve, reject) => {
    window.FB.login(
      async function(response: any) {
        if (response.authResponse) {
          try {
            // Get WhatsApp Business Account info
            const result = await new Promise((resolve, reject) => {
              window.FB.api(
                '/me/whatsapp_business_accounts',
                'GET',
                { access_token: response.authResponse.accessToken },
                function(response: any) {
                  if (response.error) {
                    reject(new Error(response.error.message));
                  } else {
                    resolve(response);
                  }
                }
              );
            });

            if (!result.data || !result.data[0] || !result.data[0].id) {
              throw new Error('No se encontró una cuenta de WhatsApp Business');
            }

            resolve({
              accessToken: response.authResponse.accessToken,
              phoneNumberId: result.data[0].id
            });
          } catch (error) {
            reject(error);
          }
        } else {
          reject(new Error('No se pudo iniciar sesión con Facebook'));
        }
      },
      {
        scope: 'business_management,whatsapp_business_management,whatsapp_business_messaging',
        return_scopes: true,
        enable_profile_selector: true,
        auth_type: 'rerequest'
      }
    );
  });
}

export function generateVerifyToken(): string {
  // Generate a random string and hash it
  const randomString = Math.random().toString(36).substring(2, 15);
  const timestamp = new Date().getTime().toString();
  const hash = SHA256(randomString + timestamp);
  
  // Take first 16 characters of the hash
  return hash.toString().substring(0, 16);
}